export default "__VITE_ASSET__yL6ahKzf__"